import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPageLeftArrow = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 52,
	height: 52,
	viewBox: "0 0 52 52",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: 51.5,
		y: 51.5,
		width: 51,
		height: 51,
		transform: "rotate(-180 51.5 51.5)",
		stroke: "#909090"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M30.9725 39L34.0275 35.945L24.1041 26L34.0275 16.055L30.9725 13L17.9725 26L30.9725 39Z",
		fill: "#90919C"
	})]
});
export default SvgPageLeftArrow;
